import React from 'react';
import PrintLayout from './PrintLayout';

export default function PrintSection({ pageNumber, eyebrow, title, body, pullQuote, pullQuoteSource, chartTitle, chartOnly, children }) {
  if (chartOnly) {
    return (
      <PrintLayout pageNumber={pageNumber}>
        <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, background: '#f5f4f0', padding: '4%', display: 'flex', flexDirection: 'column' }}>
          {chartTitle && (
            <div style={{
              fontSize: 9, fontWeight: 700, letterSpacing: '1.5px', color: '#6b757e',
              textTransform: 'uppercase', marginBottom: 10, fontFamily: 'Montserrat, sans-serif',
            }}>
              {chartTitle}
            </div>
          )}
          <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            {children}
          </div>
        </div>
      </PrintLayout>
    );
  }

  return (
    <PrintLayout pageNumber={pageNumber}>
      <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, display: 'flex' }}>
        {/* Left: dark navy panel */}
        <div style={{
          width: '32%', background: '#1e2e45',
          padding: '6% 5%', display: 'flex', flexDirection: 'column',
        }}>
          <div style={{
            fontSize: 9, fontWeight: 700, letterSpacing: '2px', color: '#5f7942',
            textTransform: 'uppercase', marginBottom: 10, fontFamily: 'Montserrat, sans-serif',
          }}>
            {eyebrow}
          </div>
          <div style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 22, fontWeight: 700, color: '#fff', lineHeight: 1.2, marginBottom: 14,
          }}>
            {title}
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.65)', lineHeight: 1.75 }}>
            {body}
          </div>
          {pullQuote && (
            <div style={{
              marginTop: 16, padding: '10px 12px',
              borderLeft: '2px solid #5f7942',
              fontSize: 10, fontStyle: 'italic',
              color: 'rgba(255,255,255,0.5)', lineHeight: 1.65,
            }}>
              "{pullQuote}"
              {pullQuoteSource && (
                <div style={{ marginTop: 4, fontStyle: 'normal', fontWeight: 600, color: 'rgba(255,255,255,0.3)' }}>
                  — {pullQuoteSource}
                </div>
              )}
            </div>
          )}
        </div>
        {/* Right: chart panel */}
        <div style={{
          width: '68%', background: '#f5f4f0',
          padding: '4%', display: 'flex', flexDirection: 'column', justifyContent: 'center',
        }}>
          {chartTitle && (
            <div style={{
              fontSize: 9, fontWeight: 700, letterSpacing: '1.5px', color: '#6b757e',
              textTransform: 'uppercase', marginBottom: 10, fontFamily: 'Montserrat, sans-serif',
            }}>
              {chartTitle}
            </div>
          )}
          <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            {children}
          </div>
        </div>
      </div>
    </PrintLayout>
  );
}
